import React from 'react'
import { Link } from 'react-router-dom'
import '../assets/css/components/profile-card.css'

const ProfileCard = ({ profile, uuid, link }) => {
  const getProfileName = ()=> {
    if(profile.last_name) {
      return profile.first_name + ' ' + profile.last_name
    } else {
      return profile.first_name
    }
  }

  return(
    <div className="col-sm-12 col-md-6 col-lg-3 m-b-10 profile-card">
      <div className="ar-1-1">
        <div className="card no-border bg-primary widget widget-loader-circle-lg no-margin">
          {link && <Link to={link} className='ab-link'></Link>}
          <div className="card-block">
            <div className="pull-bottom bottom-left bottom-right padding-25">
              <br/>
              <h3 className="text-white">{getProfileName()}</h3>
              <p className="text-white hint-text hidden-lg-down">{profile.character_name}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ProfileCard
